import { message } from "antd";

import { fiscalQuarterOption } from "../app/HR/component/utils";
import { JWT_TOKEN } from "../constant";
import { getLocalStorage } from "../utils/storageUtil";
import { jwtDecode } from "jwt-decode";

export const isAuthenticated = () => {
  if (localStorage.getItem(JWT_TOKEN)) {
    return true;
  }
  return false;
};

export const currencyFormatter = (amt) => {
  if (!amt) {
    return 0;
  }
  const formatter = new Intl.NumberFormat("en-NP", {});
  return formatter.format(amt);
};

export const exportToExcel = (dataSource, fileName) => {
  if (dataSource?.length > 0) {
    const formatedData = dataSource.map((obj) => {
      const newObj = {};
      for (let key in obj) {
        if (obj?.hasOwnProperty(key)) {
          newObj[key] = obj[key]?.toString()?.replace(/,/g, " - ");
        }
      }
      return newObj;
    });
    if (formatedData?.length > 0) {
      const csvContent =
        "data:text/csv;charset=utf-8," +
        Object.keys(formatedData?.[0])?.join(",") +
        "\n" + // Headers
        formatedData?.map((obj) => Object?.values(obj)?.join(","))?.join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", fileName + ".csv");
      document.body.appendChild(link); // Required for Firefox
      link.click();
      message.success("File exported to excel");
    }
  } else {
    message.error("Cannot export empty data");
  }
};

export const getQuarterName = (quarter) => {
  if (!quarter) return "-";
  return fiscalQuarterOption?.find((item) => item?.value === quarter)?.label;
};
export const joinTwoArrayByMemberId = (array1 = [], array2 = []) => {
  // Maps for quick lookup
  const map1 = new Map(array1.map((item) => [item.member_id, item]));
  const map2 = new Map(array2.map((item) => [item.member_id, item]));

  // Get union of all member_ids
  const allIds = new Set([...map1.keys(), ...map2.keys()]);

  const result = Array.from(allIds).map((id) => {
    const item1 = map1.get(id) || {};
    const item2 = map2.get(id) || {};
    return {
      Recruitment: item2.ratio ?? 0,
      Turnover: item1.ratio ?? 0,
      member_id: id,
      member_name: item1.member_name || item2.member_name || "Unknown",
    };
  });
  return result;
};

export const getPositionOptionWithLevel = (position) => {
  if (!position) return [];

  return position?.map((item) => {
    return {
      value: item?.value,
      label: `${item?.label} (${item?.Level})`,
      position: item?.label,
    };
  });
};

export const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  message.success("File exported to excel");
  // Cleanup
  a.remove();
  URL.revokeObjectURL(url);
};

export const checkRoles = (role) => {
  const token = getLocalStorage(JWT_TOKEN);
  const decoded = jwtDecode(token);

  if (decoded?.role === "ADMIN" || role?.includes("ALL")) {
    return true;
  }

  if (role?.includes(decoded?.role)) {
    return true;
  }
  return false;
};

export const convertToNumber = (number) => {
  if (!isNaN(number)) {
    return Number(number);
  } else {
    return number;
  }
};
